import { render, staticRenderFns } from "./ImportHistoryTable.vue?vue&type=template&id=7c345675&"
import script from "./ImportHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./ImportHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./ImportHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports